import React from 'react';

const ManageForm = () => {
    return (
        <div>
            this is Form page
        </div>
    );
};

export default ManageForm;